"use strict";
/*
* Created on 20.05.2019
*/

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Lost sale converter.
 *
 * @author ZSr
 */


var LostSaleConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(LostSaleConverter, _DataObjectConverter_);

  function LostSaleConverter() {
    _classCallCheck(this, LostSaleConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(LostSaleConverter).apply(this, arguments));
  }

  return LostSaleConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.LostSaleConverter = LostSaleConverter;